import { Component } from '@angular/core';
import { BottomNavComponent } from "../shared/components/footer/bottom-nav/bottom-nav.component";
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [BottomNavComponent, CommonModule, RouterLink],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
    callouts = [
        {
            "icon": "bi-heart-pulse-fill",
            "title": "HEALTH",
            "description": "The health of your family is the crucial foundation to thrive physically and emotionally. Family Health Advantage offers an affordable way for the whole family to access the benefits of conservative care."
        },
        {
            "icon": "bi-people",
            "title": "UNITY",
            "description": "Maintaining family health encourages a lifestyle of wellness and shared responsibility, benefiting each member, and strengthening family unity. Family Health Advantage is designed for the whole family, not just for one individual."
        },
        {
            "icon": "bi-check2-all",
            "title": "RELIABILITY",
            "description": "Reliability is not just a principle; it is the cornerstone of Family Health Advantage’s provider network.  We understand that consistent, dependable care is essential for building trust and ensuring the well-being of your entire family."
        }
    ];
    testimonials= [
      {
          "active": true,
          "testimonial": "\"Thanks to the coupon I found, I saved $50 on my chiropractic session this week! It's such a relief to have a little extra money in my pocket, and it really helps my budget. I'm so grateful for the savings – it makes a big difference for my family.\""
      },
      {
          "active": false,
          "testimonial": "\"I'm thrilled to have found a coupon that saved me $50 on my recent chiropractic session! It's a great feeling knowing that I'm taking care of my health while also saving some money. This discount has made a real difference for me and my family.\""
      },
      {
          "active": false,
          "testimonial": "\"Thanks to a special coupon, I saved $50 on my chiropractic session. It's a great feeling to prioritize my health and save money at the same time. This discount has really made a positive impact for both me and my family.\""
      }
  ];
}
